/* eslint-disable max-len */
import KishuQuestion from 'images/coin-pages/questions/hishu.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const kishuPage: ICoinPageData = {
  title: 'coin_589',
  description: 'coin_590',
  // description: 'coin_591',
  h1: (t: (key: unknown) => any) => (
    <>
      {t('borrow_against_bone')} <span style={{ color: '#f90' }}>Kishu Inu</span>
    </>
  ),
  questionsBlock: {
    image: KishuQuestion,
    questions: [
      {
        title: 'coin_592',
        answer: 'coin_593',
      },
      {
        title: 'coin_594',
        answer: 'coin_595',
      },
      {
        title: 'coin_596',
        answer: 'coin_597',
      },
      {
        title: 'coin_598',
        answer: 'coin_599',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('KISHU (KISHU)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_600',
        text: ['coin_602'],
      },
      {
        title: 'coin_601',
        text: ['coin_603'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/kishu-inu-coin-loans/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_2400/https://coinrabbit.io/blog/wp-content/uploads/2023/03/Kishu_loans.png',
        imageAlt: 'Kishu Inu Crypto loans – All You Need to Know',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
